import { createTheme, type PaletteMode } from "@mui/material";

/** MUI theme. Shared design decisions live here, not in component sx props. */
export const createAppTheme = (mode: PaletteMode) =>
    createTheme({
        cssVariables: true,
        palette: {
            mode,
        },
        shape: {
            borderRadius: 8,
        },
        typography: {
            fontFamily: [
                "-apple-system",
                "BlinkMacSystemFont",
                "Segoe UI",
                "Roboto",
                "Helvetica Neue",
                "Arial",
                "sans-serif",
            ].join(","),
        },
    });
